import { useState, useEffect } from 'react'
import AppShell from './AppShell'
import DesktopShell from './DesktopShell'
import { useBillingStatusSync } from '../../hooks/useBillingStatusSync'

export default function ResponsiveShell({ title, children }) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024)
  useBillingStatusSync()

  useEffect(() => {
    const handler = () => setIsDesktop(window.innerWidth >= 1024)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  if (isDesktop) return <DesktopShell>{children}</DesktopShell>
  return <AppShell title={title}>{children}</AppShell>
}
